import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from 'antd';

import './PageTitle.less';

const PageTitle = ({title, level = 3, icon}) => {
    return (
        <Typography.Title level={level} className="page-title">
            {icon && <span className="page-title-icon">{icon}</span>}
            <span>{title}</span>
        </Typography.Title>
    );
};

PageTitle.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.object,
    level: PropTypes.number,
};

PageTitle.defaultProps = {
    icon: null,
};

export default PageTitle;